module.exports = __webpack_public_path__ + "img/klyr-logo.1f1f25c.png";